import React, { Component, PropTypes } from 'react'
import styled from 'styled-components'
import R from 'ramda'
import Grid, { Half } from 'grid-styled'
import { translate } from 'react-i18next'
import CardContainer from '../../components/CardContainer'
import { Metrics, Fonts } from '../../Themes'
import Input from '../../components/Input'
import Button from '../../components/Button'
import { validateInput, validateForm } from '../../Utils/Validations'
import Dropdown from '../../components/Dropdown'
import { numberWithCommas } from '../../Utils'
import { generateSalesMandate } from '../../sources/ContractsSource'
import Loader from '../../components/Loader'

const CustomGrid = styled(Grid)`
  padding-left: ${Metrics.margins.medium};
  padding-right: ${Metrics.margins.medium};
  button {
    margin-top: ${Metrics.margins.base};
    float: right
  }

  @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
    padding: 0;
  }
`

const CustomHalf = styled(Half)`
  margin-top: ${props => (props.noPadTop ? 0 : Metrics.margins.base)};
  padding-left: ${Metrics.margins.medium};
  padding-right: ${Metrics.margins.medium};

  @media screen and (max-width: ${Metrics.breakpoints.mobile}) {
    padding: 0;
  }
`

const CustomCardContainer = styled(CardContainer)`
  height: 100%;
`

const List = styled.ul`
  padding-left: 0;
  list-style: none;
  ${Fonts.style.Text};

  li {
    margin: ${Metrics.margins.base} 0;
    padding-bottom: ${Metrics.margins.small};
    border-bottom: ${Metrics.borders.default};

    li {
      padding-bottom: 0;
      margin: ${Metrics.margins.small} 0;
      border-bottom: none;
    }
  }
`

const Terms = styled.div`
  ${Fonts.style.Text};
  margin-top: ${Metrics.margins.base};
`

const Title = styled.div`
  margin-bottom: ${Metrics.margins.small};
  ${Fonts.style.Label};
`

class SalesMandate extends Component {
  constructor (props) {
    super(props)
    let commissions = []
    let commission = 0.25
    while (commission <= 5) {
      commissions.push(`${commission}%`)
      commission += 0.25
    }
    this.state = {
      options: commissions,
      mandateType: '',
      period: '',
      propertyName: '',
      propertyPrice: '',
      propertyAddress: '',
      propertyType: '',
      commission: '',
      name: '',
      company: '',
      address: '',
      phoneNumber: '',
      email: '',
      generating: false,
      errors: {
        mandateType: '',
        period: '',
        propertyName: '',
        propertyPrice: '',
        propertyAddress: '',
        propertyType: '',
        commission: '',
        name: '',
        company: '',
        address: '',
        phoneNumber: '',
        email: ''
      }
    }
    this.handleChange = this.handleChange.bind(this)
    this.downloadFile = this.downloadFile.bind(this)
    this.handleValidate = this.handleValidate.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
  }

  handleChange (event, key) {
    const state = R.clone(this.state)
    state[key] = event.target.value
    this.setState(state)
  }

  handleSelect (el, key) {
    const state = R.clone(this.state)
    state[key] = el.toString()
    this.setState(state)
  }

  downloadFile () {
    const { errors } = this.state
    let validation = validateForm(this.state, errors)

    if (validation.valid) {
      this.setState({ generating: true }, () => {
        generateSalesMandate({
          mandateType: this.state.mandateType,
          period: this.state.period,
          propertyName: this.state.propertyName,
          propertyPrice: `${numberWithCommas(this.state.propertyPrice)}€`,
          propertyAddress: this.state.propertyAddress,
          propertyType: this.state.propertyType,
          commission: this.state.commission,
          name: this.state.name,
          company: this.state.company,
          address: this.state.address,
          phoneNumber: this.state.phoneNumber,
          email: this.state.email
        })
          .then(response => {
            this.setState({ generating: false })
            document.location = response.data.url
          })
          .catch(console.error)
      })
    } else {
      this.setState({ errors: validation.errors })
    }
  }

  handleValidate (name, value, errors) {
    let newErrors = validateInput(name, value, errors)
    this.setState({ errors: newErrors })
  }

  render () {
    const { t } = this.props
    const { errors } = this.state

    let keys = [
      { key: 'name', label: t('Name'), placeholder: t('Name') },
      { key: 'company', label: t('Company'), placeholder: t('Company Name') },
      {
        key: 'address',
        label: t('Address'),
        placeholder: t('Company Address')
      },
      { key: 'phoneNumber', label: t('Phone'), placeholder: t('Phone Number') },
      { key: 'email', label: t('Email'), placeholder: t('E-mail') }
    ]

    let propertyKeys = [
      {
        key: 'propertyName',
        label: t('Property Name'),
        placeholder: t('Name')
      },
      {
        key: 'propertyAddress',
        label: t('Property Address'),
        placeholder: t('Street, number, city, postal code, country')
      },
      {
        key: 'propertyPrice',
        label: t('Property Price'),
        placeholder: t('Price')
      }
    ]

    let propertyTypes = [
      'Commercial',
      'Residential',
      'Mixed-use',
      'Hotel',
      'Other'
    ]

    let periods = [ '3 Months', '6 months', '1 year', '2 years' ]

    let mandateTypes = [ 'Exclusive', 'Non-Exclusive' ]

    return (
      <CustomCardContainer title={t('Sales Mandate')}>
        <Loader visible={this.state.generating} />
        {propertyKeys.map((el, index) => {
          return (
            <CustomHalf
              key={el.key}
              noPadLeft={index % 2 === 0}
              noPadRight={index % 2 === 1}>
              <Input
                placeholder={el.placeholder}
                name={el.key}
                required
                title={el.label}
                value={this.state[el.key]}
                handleChange={event => this.handleChange(event, el.key)}
                error={errors[el.key]}
                handleBlur={event =>
                  this.handleValidate(el.key, this.state[el.key], errors)}
              />
            </CustomHalf>
          )
        })}

        <CustomHalf key={'propertyType'} noPadRight>
          <Title>{t('Property Type')}</Title>
          <Dropdown
            placeholder={t('Select the type of property')}
            options={propertyTypes}
            selectedOption={this.state.propertyType}
            handleSelect={el => this.handleSelect(el, 'propertyType')}
            error={errors.propertyType}
            handleBlur={event =>
              this.handleValidate(
                'propertyType',
                this.state.propertyType,
                errors
              )}
            name={'propertyType'}
            required
          />
        </CustomHalf>

        <CustomHalf key={'mandateType'} noPadRight>
          <Title>{t('Mandate Type')}</Title>
          <Dropdown
            placeholder={t('Select the type of mandate')}
            options={mandateTypes}
            selectedOption={this.state.mandateType}
            handleSelect={el => this.handleSelect(el, 'mandateType')}
            error={errors.mandateType}
            handleBlur={event =>
              this.handleValidate(
                'mandateType',
                this.state.mandateType,
                errors
              )}
            name={'mandateType'}
            required
          />
        </CustomHalf>

        <CustomHalf key={'period'} noPadRight>
          <Title>{t('Mandate Period')}</Title>
          <Dropdown
            placeholder={t('Select the period of mandate')}
            options={periods}
            selectedOption={this.state.period}
            handleSelect={el => this.handleSelect(el, 'period')}
            error={errors.period}
            handleBlur={event =>
              this.handleValidate('period', this.state.period, errors)}
            name={'period'}
            required
          />
        </CustomHalf>

        <CustomHalf key={'commission'} noPadRight>
          <Title>{t('Commission')}</Title>
          <Dropdown
            placeholder={t('Select commission value')}
            options={this.state.options}
            selectedOption={this.state.commission}
            handleSelect={el => this.handleSelect(el, 'commission')}
            error={errors.commission}
            handleBlur={event =>
              this.handleValidate('commission', this.state.commission, errors)}
            name={'commission'}
            required
          />
        </CustomHalf>

        <CustomGrid>
          <Terms>
            <List>
              <li>
                <Title>Property Detail</Title>
                <p>
                  Property Name:{' '}
                  <b>{this.state.propertyName || t('PROPERTY NAME')}</b>
                </p>
                <p>
                  Address:{' '}
                  <b>{this.state.propertyAddress || t('PROPERTY ADDRESS')}</b>
                </p>
                <p>
                  Type: <b>{this.state.propertyType || t('PROPERTY TYPE')}</b>
                </p>
                This listing is off-market and confidential. The listing will be
                made on HvB’s private and secured web-based portfolio in an
                anonymised fashion by using broad indications as to price, type
                of property, size, estimate yield, approximate location etc.
              </li>
              <li>
                <Title>Agent Appointment</Title>
                We/I hereby appoint HvB to act as a Seller’s Agent for the
                above-mentioned Property. HvB shall actively search, identify
                and propose a buyer for the Property under the following terms:
                <p>
                  Type of mandate:{' '}
                  <b>{this.state.mandateType || t('MANDATE TYPE')}</b>
                </p>
                <p>
                  Appointment Period: <b>{this.state.period || t('PERIOD')}</b>
                </p>
                <p>
                  Should any sale be concluded within 12 months after the end of
                  the appointment period, with a lead introduced by HvB during
                  the appointment period, the below agreed brokerage fees are
                  still due.
                </p>
              </li>
              <li>
                <Title>Listing Price and Brokerage Fees</Title>
                <p>
                  Listing Price:{' '}
                  <b>
                    {this.state.propertyPrice ? (
                      `${numberWithCommas(this.state.propertyPrice)}€`
                    ) : (
                      t('PROPERTY PRICE')
                    )}
                  </b>
                </p>
                <p>
                  Currency: <b>{t('EUR')}</b>
                </p>
                <p>
                  Brokerage Fee: <b>{this.state.commission || t('FEE')}</b>
                </p>
              </li>
              <li>
                <Title>Governing law and jurisdiction</Title>
                This Agreement shall in all respects be governed by and
                construed in accordance with Swiss law, without giving effect to
                its conflict of law principles. All disputes arising from or in
                connection with this Agreement, including disputes regarding its
                conclusion, validity, binding effect, amendment, breach,
                termination or rescission, shall be subject to the exclusive
                jurisdiction of courts of the Canton of Zurich.
              </li>
            </List>
          </Terms>
        </CustomGrid>

        {keys.map((el, index) => {
          return (
            <CustomHalf
              key={el.key}
              noPadLeft={index % 2 === 0}
              noPadRight={index % 2 === 1}>
              <Input
                placeholder={el.placeholder}
                name={el.key}
                required
                title={el.label}
                value={this.state[el.key]}
                handleChange={event => this.handleChange(event, el.key)}
                error={errors[el.key]}
                handleBlur={event =>
                  this.handleValidate(el.key, this.state[el.key], errors)}
              />
            </CustomHalf>
          )
        })}
        <CustomGrid>
          <Button label={t('Download')} onClick={this.downloadFile} />
        </CustomGrid>
      </CustomCardContainer>
    )
  }
}

SalesMandate.propTypes = {
  t: PropTypes.func,
  router: PropTypes.object,
  children: PropTypes.node
}

export default translate([ 'common', 'forms', 'admin' ], { wait: true })(
  SalesMandate
)



// WEBPACK FOOTER //
// ./src/pages/Agreements/SalesMandate.js